<p
  [id]="textContentModel?.id"
  [style.font-family]="textContentModel?.fontFamily"
  [style.font-weight]="textContentModel?.fontWeight"
  [style.font-size.px]="textContentModel?.fontSize"
  [style.line-height.px]="textContentModel?.lineHeight"
  [style.color]="textContentModel?.color"
  [style.margin-bottom]="textContentModel?.marginBottom"
  [style.margin-top]="textContentModel?.marginTop"
  [style.margin-left]="textContentModel?.marginLeft"
  [style.margin-right]="textContentModel?.marginRight"
  [class]="
    !!textContentModel?.fontTypeKey
      ? 'font-' + textContentModel?.fontTypeKey
      : 'pg-text-content'
  "
  [style.textAlign]="textContentModel?.alignContent"
  [innerHTML]="textContentModel?.content"
>
  <!-- {{ textContentModel?.content }} -->
</p>
